import { memo } from 'react';
function CaretDownFilled() {
	return (
		<svg
			width="11"
			height="7"
			viewBox="0 0 11 7"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.51348 6.5L0.410186 0.774345L10.6168 0.774344L5.51348 6.5Z"
				fill="#787878"
			/>
		</svg>
	);
}

export default memo(CaretDownFilled);
